import { IonAlert } from '@ionic/react';

interface DeleteConfirmAlertProps {
  isOpen: boolean;
  header: string;
  message: string;
  onDidDismiss: () => void;
  onConfirm: () => void;
}

// Confirmation dialog shared by the post detail screen and the post editor (drafts and photos).
// The destructive "Eliminar" action triggers onConfirm; header/message are
// passed in so each caller can name the entity ("publicación" / "borrador" / "foto").
export const DeleteConfirmAlert = ({
  isOpen,
  header,
  message,
  onDidDismiss,
  onConfirm,
}: DeleteConfirmAlertProps) => (
  <IonAlert
    isOpen={isOpen}
    header={header}
    message={message}
    onDidDismiss={onDidDismiss}
    buttons={[
      {
        text: 'Cancelar',
        role: 'cancel',
        handler: onDidDismiss,
      },
      {
        text: 'Eliminar',
        role: 'destructive',
        handler: onConfirm,
      },
    ]}
  />
);
